import { styled } from 'goober'
import { forwardRef } from 'react'

export const CardListTitleContainer = styled('div')`
  display: flex;
  width: 100%;
  gap: 1em;
  align-items: center;
`

export const CardListTitle = styled('h2')`
  margin-block: 0;
`

export const CardListContainer = styled('div', forwardRef)`
  display: flex;
  gap: .4em;
  margin-block-start: 1em;
  margin-block-end: 3em;
  flex-wrap: wrap;
  align-items: flex-start;
`
